import axios from '@/lib/axios';
import { useQuery } from '@tanstack/react-query';

/**
 * 2450. 収支ダッシュボード（月次分析）
 * [GET] /workspaces/:identifier/pl_dashboard/monthly_analysis
 */
type Props = {
  identifier: string;
  team_ids?: number[];
  user_ids?: number[];
  fiscal_year?: number;
  use_external_expense?: boolean;
};

export type PlDashboardMonthlyAnalysis = {
  target_year_month: number[];
  external_expense_cumulative_amounts: number[]; // Node管理外費用月次累計  ※必ず12ヶ月分存在
  external_expense_amounts: number[]; // Node管理外費用月次  ※必ず12ヶ月分存在
  purchase_preparing_cumulative_amounts: number[]; // Purchase稟議準備月次累計  ※必ず12ヶ月分存在
  purchase_preparing_amounts: number[]; // Purchase稟議準備月次  ※必ず12ヶ月分存在
  purchase_contracting_cumulative_amounts: number[]; // Purchase契約中月次累計  ※必ず12ヶ月分存在
  purchase_contracting_amounts: number[]; // Purchase契約中月次  ※必ず12ヶ月分存在
  purchase_completed_cumulative_amounts: number[]; // Purchase契約終了月次累計  ※必ず12ヶ月分存在
  purchase_completed_amounts: number[]; // Purchase契約終了月次  ※必ず12ヶ月分存在
  sales_attack_list_cumulative_amounts: number[]; // アタックリスト月次累計  ※必ず12ヶ月分存在
  sales_attack_list_amounts: number[]; // アタックリスト月次  ※必ず12ヶ月分存在
  sales_initial_proposal_cumulative_amounts: number[]; // 初期提案月次累計  ※必ず12ヶ月分存在
  sales_initial_proposal_amounts: number[]; // 初期提案月次  ※必ず12ヶ月分存在
  sales_detail_proposal_cumulative_amounts: number[]; // 詳細提案月次累計  ※必ず12ヶ月分存在
  sales_detail_proposal_amounts: number[]; // 詳細提案月次  ※必ず12ヶ月分存在
  sales_under_negotiation_cumulative_amounts: number[]; // 交渉中月次累計  ※必ず12ヶ月分存在
  sales_under_negotiation_amounts: number[]; // 交渉中月次  ※必ず12ヶ月分存在
  sales_contracting_cumulative_amounts: number[]; // 契約中月次累計  ※必ず12ヶ月分存在
  sales_contracting_amounts: number[]; // 契約中月次  ※必ず12ヶ月分存在
  sales_completed_cumulative_amounts: number[]; // 契約終了月次累計  ※必ず12ヶ月分存在
  sales_completed_amounts: number[]; // 契約終了月次  ※必ず12ヶ月分存在
  balance_cumulative_amounts: number[]; // 収支月次累計  ※必ず12ヶ月分存在
  balance_amounts: number[]; // 収支月次  ※必ず12ヶ月分存在
  sales_order_phase_labels: {
    attack_list: string;
    initial_proposal: string;
    detail_proposal: string;
    under_negotiation: string;
    contracting: string;
    lost_order: string;
    pending: string;
    completed: string;
  };
  purchase_order_phase_labels: {
    preparing: string;
    contracting: string;
    completed: string;
    stopped: string;
  };
};
const plDashboardMonthlyAnalysis = (props: Props): Promise<PlDashboardMonthlyAnalysis> => {
  return axios.get(`/api/workspaces/${props.identifier}/pl_dashboard/monthly_analysis`, { params: props });
};

export const usePlDashboardMonthlyAnalysis = (props: Props) => {
  return useQuery({
    queryKey: ['workspaces', props.identifier, 'pl_dashboard', 'monthly_analysis', { ...props }],
    queryFn: () => plDashboardMonthlyAnalysis(props),
    staleTime: 1000 * 60 * 30,
  });
};
